export const PAYDAYS = [
    { value: '0', label: '0' },
    { value: '7', label: '7' },
    { value: '14', label: '14' },
    { value: '21', label: '21' },
    { value: '30', label: '30' }
];